import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../../components/Loader';
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from '../../../utils/toastHelper';
import {
  downloadPdf,
  printView,
  updateBulkOrders,
} from '../services/ordersService';

export default function FBZOrdersTable({
  permissionKey,
  orders,
  loading,
  isAllSelected,
  handleSelectAllChange,
  selectedOrders,
  handleRowSelect,
  permissions,
  orderStatuses,

  openEditModal,
  openViewModal,
  openAddModal,
  colorMappings,
  fetchData,
  pagination,
}) {
  const { t } = useTranslation('Order');
  const [downloadInfo, setDownloadInfo] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  // Toggle dropdown open/close
  const toggleDropdown = (orderId) => {
    setOpenDropdown((prev) => (prev === orderId ? null : orderId));
  };

  // Function to close the dropdown when an invoice type is selected
  const handleSelectionAndClose = (orderId, type) => {
    handleTypeSelection(orderId, type);
    setOpenDropdown(null); // Close only when selecting an invoice type
  };
  const handleDownloadInfoChange = (e, orderId) => {
    setDownloadInfo((prev) => ({
      ...prev,
      id: orderId,
      company: e.target.value,
    }));
  };
  const handleTypeSelection = (orderId, type) => {
    if (downloadInfo.id !== orderId || !downloadInfo.company) {
      showWarningToast(t('PLEASESELECTCOMPANY'));
      return;
    }

    handleDownload(orderId, type);
  };

  const handleDownload = async (orderId, type) => {
    const queryData = {
      orderId,
      type,
      company: downloadInfo.company,
    };
    try {
      const printResponse = await downloadPdf(queryData, type + '.pdf');
      if (printResponse?.success) {
        // update status//
        await updateOrderStatus(orderId);
      }
    } catch (error) {
      showErrorToast(error?.message);
    }
  };
  const updateOrderStatus = async (orderId) => {
    // update status//

    const matchedStatus = orderStatuses.find((orderStatus) =>
      ['處理中', 'processing'].includes(orderStatus.name.toLowerCase())
    );

    if (matchedStatus) {
      const response = await updateBulkOrders({
        type: 'orderStatus',
        orders: [orderId],
        action: matchedStatus.name,
        isPrint: true,
      });
      if (response.success) {
        showSuccessToast(response?.message || 'Success');
        fetchData(pagination.current_page, 1);
      }
    }
  };

  const [openPrintDropdown, setOpenPrintDropdown] = useState(null);
  const togglePrintDropdown = (orderId) => {
    setOpenPrintDropdown((prev) => (prev === orderId ? null : orderId));
  };
  const handlePrintSelection = async (orderId, type) => {
    if (downloadInfo.id !== orderId || !downloadInfo.company) {
      showWarningToast(t('PLEASESELECTCOMPANY'));
      return;
    }

    const queryData = {
      orderId,
      type,
      company: downloadInfo.company,
    };
    try {
      await printView(queryData, `${type}.pdf`); // Call printView instead of downloadPdf
    } catch (err) {
      showErrorToast(err);
    }
    setOpenPrintDropdown(null); // Close dropdown after selection
  };
  const printDropdownRef = useRef(null);

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
      if (
        printDropdownRef.current &&
        !printDropdownRef.current.contains(event.target)
      ) {
        setOpenPrintDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div
      className={`table-outer tabel-fbz ${orders.length >= 1 && orders.length <= 3 ? 'scroll' : ''}`}
    >
      <table className="table fbz-orders  order-css-change">
        <thead>
          <tr className="t-heading">
            <th className="t-checkbox">
              <label className="container">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAllChange}
                />
                <span className="checkmark"></span>
              </label>
            </th>
            <th className="delivery-date">
              <h5>{t('DELIVERYDATE')}</h5>
            </th>
            <th className="order-no">
              <h5>{t('ORDERNO')}</h5>
            </th>
            <th className="customer-info">
              <h5>{t('CUSTOMERINFO')}</h5>
            </th>
            <th className="refrence-no">
              <h5>{t('REFERENCENUMBER')}</h5>
            </th>
            <th className="refrence-no">
              <h5>{t('TOTALAMOUNT')}</h5>
            </th>

            <th className="order-status">
              <h5>{t('ORDERSTATUS')}</h5>
            </th>
            <th className="delivery-status">
              <h5>{t('DELIVERYSTATUS')}</h5>
            </th>
            <th className="payment-status">
              <h5>{t('PAYMENTSTATUS')}</h5>
            </th>
            <th className="payment-method">
              <h5>{t('PAYMENTMETHOD')}</h5>
            </th>
            <th className="payment-date">
              <h5>{t('PAYMENTDATE')}</h5>
            </th>
            <th className="action">
              <h5>{t('ACTION')}</h5>
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr className="position-relative">
              <td colSpan="100%" className="loader-container mt-5">
                <Loader />
              </td>
            </tr>
          ) : (
            <>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="100%" className="text-center py-4">
                    {t('NORECORDAVAILABLE')}
                  </td>
                </tr>
              ) : (
                orders.map((order, index) => {
                  let showUpdateColor = order.show_updated_color;
                  // let showUpdateColor=false
                  // showUpdateColor= !!order.update_time;
                  // if (
                  //   [
                  //     '處理中',
                  //     'Processing',
                  //     '完成',
                  //     'completed',
                  //     '取消',
                  //     'cancelled',
                  //   ].includes(order.status.name)
                  // ) {
                  //   showUpdateColor=false;
                  // }
                  return (
                    <tr
                      key={index}
                      className={`${!!order.read_at ? 'without-bold-change' : 'for-bold-changes'} ${
                        showUpdateColor
                          ? colorMappings.updated.class
                          : colorMappings?.[order.status?.name].class
                      }`}
                    >
                      <td className="t-checkbox">
                        <label className="container">
                          <input
                            type="checkbox"
                            checked={selectedOrders.has(order.id)}
                            onChange={(e) => handleRowSelect(e, order.id)}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </td>
                      <td className="delivery-date">{order.delivery_date}</td>
                      <td className="order-no">{order.number}</td>

                      <td className="customer customer-info">
                        <span className="d-block">
                          {order.customer?.customer_group?.group ||
                            order.customer_group?.group ||
                            ''}
                        </span>

                        <span className="d-block">
                          {order.contact_name || ''}
                        </span>
                      </td>

                      <td className="refrence-no">{order.reference_number}</td>
                      <td className="total-amount">
                        $
                        {Array.isArray(order.products)
                          ? (
                              order.products.reduce((sum, product) => {
                                const quantity = parseFloat(
                                  product?.quantity ?? 0
                                );
                                const unitPrice = parseFloat(
                                  product?.unit_price ?? 0
                                );
                                const discount = parseFloat(
                                  product?.discount ?? 0
                                );
                                return sum + (quantity * unitPrice - discount);
                              }, 0) + parseFloat(order?.additional_fee ?? 0)
                            ).toFixed(2) // optional formatting
                          : ''}
                      </td>

                      <td className="order-status">
                        <div className="dropdown">
                          <>
                            <button type="button" disabled>
                              {order.status?.name || ''}
                            </button>
                          </>
                        </div>
                      </td>
                      <td className="delivery-status">
                        <div className="dropdown">
                          <>
                            <button type="button" disabled>
                              {order.delivery_status?.name || ''}
                            </button>
                          </>
                        </div>
                      </td>
                      <td className="payment-status">
                        <div className="dropdown">
                          <>
                            {order.payment_status?.name && (
                              <button type="button" disabled>
                                {order.payment_status?.name || ''}
                              </button>
                            )}
                          </>
                        </div>
                      </td>
                      <td className="payment-method">
                        {order.customer?.payment_method?.name ||
                          order.payment_method?.name ||
                          ''}
                      </td>
                      <td className="payment-date">
                        {order.payment_date || ''}
                      </td>

                      <td className="action">
                        <div className="action-btn-change">
                          {permissions?.[permissionKey]?.edit_permission ===
                            1 && (
                            <button
                              onClick={() => {
                                openAddModal('Add-Order', order, true); // Pass `true` for clone
                              }}
                            >
                              <img
                                src={
                                  showUpdateColor
                                    ? colorMappings.updated.images?.clone
                                    : colorMappings?.[order.status?.name]
                                        ?.images?.clone
                                }
                                alt="Clone"
                              />
                            </button>
                          )}
                          {permissions?.[permissionKey]?.edit_permission ===
                            1 && (
                            <button
                              onClick={() => {
                                openEditModal(order);
                              }}
                            >
                              <img
                                src={
                                  showUpdateColor
                                    ? colorMappings.updated.images?.edit
                                    : colorMappings?.[order.status?.name]
                                        ?.images?.edit
                                }
                                alt=""
                              />
                            </button>
                          )}
                          <button
                            onClick={() => {
                              openViewModal(order);
                            }}
                          >
                            <img
                              src={
                                showUpdateColor
                                  ? colorMappings.updated.images?.view
                                  : colorMappings?.[order.status?.name]?.images
                                      ?.view
                              }
                              alt=""
                            />
                          </button>
                          <div className="dropdown print-drop-down">
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              onClick={() => togglePrintDropdown(order.id)}
                              role="button"
                            >
                              <img
                                src={
                                  showUpdateColor
                                    ? colorMappings.updated.images?.print
                                    : colorMappings?.[order.status?.name]
                                        ?.images?.print
                                }
                                alt="Print"
                              />
                            </button>

                            {openPrintDropdown === order.id && (
                              <div
                                className="dropdown-menu show"
                                ref={printDropdownRef}
                              >
                                <div className="dropdown-menu-list">
                                  <label className="d-block w-100 px-2 pt-2">
                                    {t('SELECTCOMPANY')}
                                  </label>
                                  <div className="radio">
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`print-test1-${index}`}
                                        name={`print-radio-group-${index}`}
                                        value="Fruttiboz"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Fruttiboz'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`print-test1-${index}`}>
                                        {t('FRUTTIBOZ')}
                                      </label>
                                    </p>
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`print-test2-${index}`}
                                        name={`print-radio-group-${index}`}
                                        value="Freco"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Freco'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`print-test2-${index}`}>
                                        {t('FRECO')}
                                      </label>
                                    </p>
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handlePrintSelection(
                                          order.id,
                                          'INVOICE'
                                        );
                                      }}
                                    >
                                      {t('INVOICE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handlePrintSelection(order.id, 'DN');
                                      }}
                                    >
                                      {t('DELIVERYNOTE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className={`dropdown-item ${!(downloadInfo.id === order.id && downloadInfo.company) ? 'disabled' : ''}`}
                                      onClick={(e) => {
                                        if (
                                          !(
                                            downloadInfo.id === order.id &&
                                            downloadInfo.company
                                          )
                                        ) {
                                          e.preventDefault();
                                          return;
                                        }
                                        handlePrintSelection(
                                          order.id,
                                          'RECEIPT'
                                        );
                                      }}
                                    >
                                      {t('RECEIPT')}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>

                          {/* pdf starts */}
                          <div className="dropdown">
                            {/* Trigger Button */}
                            <button
                              className="btn btn-secondary dropdown-toggle"
                              onClick={() => toggleDropdown(order.id)}
                              role="button"
                            >
                              <img
                                src={
                                  showUpdateColor
                                    ? colorMappings.updated.images?.pdf
                                    : colorMappings?.[order.status?.name]
                                        ?.images?.pdf
                                }
                                alt="PDF"
                              />
                            </button>

                            {/* Dropdown Menu */}
                            {openDropdown === order.id && (
                              <div
                                ref={dropdownRef}
                                className="dropdown-menu show"
                              >
                                <div className="dropdown-menu-list">
                                  <label className="d-block w-100 px-2 pt-2">
                                    {t('SELECTCOMPANY')}
                                  </label>
                                  <div className="radio">
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`test1-${index}`}
                                        name={`radio-group-${index}`}
                                        value="Fruttiboz"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Fruttiboz'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation(); // Prevent event bubbling
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`test1-${index}`}>
                                        {t('FRUTTIBOZ')}
                                      </label>
                                    </p>
                                    <p className="mb-0">
                                      <input
                                        type="radio"
                                        id={`test2-${index}`}
                                        name={`radio-group-${index}`}
                                        value="Freco"
                                        checked={
                                          downloadInfo.id === order.id &&
                                          downloadInfo.company === 'Freco'
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation(); // Prevent event bubbling
                                          handleDownloadInfoChange(e, order.id);
                                        }}
                                      />
                                      <label htmlFor={`test2-${index}`}>
                                        {t('FRECO')}
                                      </label>
                                    </p>
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleSelectionAndClose(
                                          order.id,
                                          'INVOICE'
                                        )
                                      }
                                    >
                                      {t('INVOICE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleSelectionAndClose(order.id, 'DN')
                                      }
                                    >
                                      {t('DELIVERYNOTE')}
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleSelectionAndClose(
                                          order.id,
                                          'RECEIPT'
                                        )
                                      }
                                    >
                                      {t('RECEIPT')}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                          {/* pdf ends */}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
}
